const hasIdentity = value => value !== null && typeof value !== 'undefined' && value !== ''

const findPrimaryLink = (links, extractedSubstanceId) => {
    if (!hasIdentity(extractedSubstanceId)) {
        return null
    }

    const candidates = links
        .map((link, sourceIndex) => ({ link, sourceIndex }))
        .filter(item => item.link
            && hasIdentity(item.link.extractedSubstanceId)
            && String(item.link.extractedSubstanceId) === String(extractedSubstanceId))

    return candidates.find(item => item.link.status === 'accepted') || candidates[0] || null
}

const buildSubstanceReviewViewModel = (substances, links, summariesById, checkerRegistry) => {
    const substanceRows = Array.isArray(substances) ? substances : []
    const linkRows = Array.isArray(links) ? links : []
    const assignedLinkIndexes = new Set()

    const items = substanceRows.map((substance, index) => {
        const linked = findPrimaryLink(linkRows, substance && substance.extractedSubstanceId)
        if (linked) {
            assignedLinkIndexes.add(linked.sourceIndex)
        }
        const substanceId = linked && linked.link ? linked.link.substanceId : null
        const summary = hasIdentity(substanceId)
            ? summariesById[String(substanceId)] || null
            : null
        const evaluation = checkerRegistry.evaluate({
            substance: substance || {},
            link: linked ? linked.link : null,
            summary,
        })

        return {
            index,
            rowKey: hasIdentity(substance && substance.extractedSubstanceId)
                ? `substance-${substance.extractedSubstanceId}`
                : `substance-index-${index}`,
            substance: substance || {},
            link: linked ? linked.link : null,
            linkIndex: linked ? linked.sourceIndex : null,
            summary,
            evaluation,
        }
    })

    return {
        items,
        unassignedLinks: linkRows
            .map((link, sourceIndex) => ({ link, sourceIndex }))
            .filter(item => !assignedLinkIndexes.has(item.sourceIndex)),
    }
}

export {
    buildSubstanceReviewViewModel,
    findPrimaryLink,
    hasIdentity,
}
